import {
  APPLY,
  SET_FILTERS,
  SET_METRICS,
  SET_DIMENSION,
  CHANGE_LOCATION,
  SET_TABLE_SETTINGS,
  SEARCH,
  SET_SELECTED_IDS,
  SET_ADVANCED_FILTERS,
} from './constants';

export function creativesTrackerReducer(state = { ready: false }, action) {
  switch (action.type) {
    case APPLY: {
      return {
        ...action.payload,
      };
    }
    case SET_METRICS: {
      const { orderBy } = state.tableSettings.orderBy;
      if (action.payload.includes(orderBy)) {
        return {
          ...state,
          metrics: action.payload,
        };
      } else if (action.payload?.length) {
        return {
          ...state,
          tableSettings: {
            ...state.tableSettings,
            orderBy: action.payload[0],
            orderDir: 'asc',
          },
          metrics: action.payload,
        };
      } else {
        return {
          ...state,
          tableSettings: {
            ...state.tableSettings,
            orderBy: '',
            orderDir: 'asc',
          },
          metrics: action.payload,
        };
      }
    }

    case SET_ADVANCED_FILTERS:
      return {
        ...state,
        advancedFilters: action.payload,
        tableSettings: {
          ...state.tableSettings,
          offset: 0,
        },
      };

    case SET_DIMENSION: {
      return {
        ...state,
        selectedIds: [], // reset selected ids on changing dimension
        dimension: action.payload,
      };
    }
    case CHANGE_LOCATION: {
      return { ...action.payload };
    }

    case SET_SELECTED_IDS: {
      return {
        ...state,

        // reset table settings on changing filters
        tableSettings: {
          ...state.tableSettings,
          offset: 0,
        },
        selectedIds: action.payload,
      };
    }
    case SET_FILTERS:
      return {
        ...state,
        // reset table settings on changing filters
        ready: true,
        tableSettings: {
          ...state.tableSettings,
          offset: 0,
        },
        filtersCollection: action.payload,
      };

    case SET_TABLE_SETTINGS:
      return {
        ...state,
        tableSettings: { ...state.tableSettings, ...action.payload },
      };

    case SEARCH:
      return {
        ...state,
        // reset table settings on changing search
        // tableSettings: {
        //   ...tableSettingsSchema.default(),
        //   limit: state.tableSettings.limit,
        // },
        searchQuery: action.payload,
      };

    default:
      return state;
  }
}
